import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button } from 'react-bootstrap';

import { isOpen } from 'helpers/order';
import { addNotification } from 'actions/NotificationsActions';

import DataId from 'components/DataId';

import OrderCancelOrder from 'components/modals/OrderCancelOrder';
import OrderFullRefund from 'components/modals/OrderFullRefund';
// import OrderUploadSalesContract from 'components/modals/OrderUploadSalesContract'
import OrderEnterBankData from 'components/modals/OrderEnterBankData';
import OrderSendPickupInvite from 'components/modals/OrderSendPickupInvite';
import OrderPickedUp from 'components/modals/OrderPickedUp';

import may from 'js/security';

class OrderActions extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isActive: false,
      showCancelOrder: false,
      showFullRefund: false,
      showEnterBankData: false,
      showSendPickupInvite: false,
      showMarkPickedUp: false,
    };
  }

  showCancelOrder = () => {
    const { actionExecuted } = this.props;

    actionExecuted('showCancelOrder');
    this.setState({ showCancelOrder: true, isActive: true });
  };

  closeCancelOrder = () => {
    this.setState({ showCancelOrder: false, isActive: false });
  };

  showFullRefund = () => {
    const { actionExecuted } = this.props;

    actionExecuted('showFullRefund');
    this.setState({ showFullRefund: true, isActive: true });
  };

  closeFullRefund = () => {
    this.setState({ showFullRefund: false, isActive: false });
  };

  showEnterBankData = () => {
    const { actionExecuted } = this.props;

    actionExecuted('showEnterBankData');
    this.setState({ showEnterBankData: true, isActive: true });
  };

  closeEnterBankData = () => {
    this.setState({ showEnterBankData: false, isActive: false });
  };

  showSendPickupInvite = () => {
    const { actionExecuted } = this.props;

    actionExecuted('showSendPickupInvite');
    this.setState({ showSendPickupInvite: true, isActive: true });
  };

  closeSendPickupInvite = () => {
    this.setState({ showSendPickupInvite: false, isActive: false });
  };

  showMarkPickedUp = () => {
    const { actionExecuted } = this.props;

    actionExecuted('showMarkPickedUp');
    this.setState({ showMarkPickedUp: true, isActive: true });
  };

  closeMarkPickedUp = () => {
    this.setState({ showMarkPickedUp: false, isActive: false });
  };

  // check if the lead that is assigned to this order is loading
  isLeadPending = () => {
    const { order, lead, leads } = this.props;
    const orderLeadId = order.lead_id || order.leadId;

    if (orderLeadId && lead.data.id !== orderLeadId) {
      return leads[orderLeadId] !== undefined ? leads[orderLeadId].pending : true;
    }

    return lead.pending;
  };

  // get lead that is linked with this order
  // returns null if the lead is not loaded yet
  getLead = () => {
    const { order, lead, leads } = this.props;
    const orderLeadId = order.lead_id || order.leadId;

    if (this.isLeadPending()) {
      return null;
    }
    if (orderLeadId && lead.data.id !== orderLeadId) {
      return leads[orderLeadId].data;
    }

    return lead.data;
  };

  // check if documents that are assigned to the lead are loading
  isLeadDocsPending = () => {
    const { leadDocs } = this.props;
    return leadDocs !== undefined ? leadDocs.pending : true;
  };

  // get the list of documents assigned to the lead
  // return null if the list is still loading
  getLeadDocs = () => {
    const { leadDocs } = this.props;

    if (this.isLeadDocsPending()) {
      return null;
    }
    return leadDocs.data.list;
  };

  // check if documents that are assigned to the client are loading
  isClientDocsPending = () => {
    const { clientDocs } = this.props;
    return clientDocs !== undefined ? clientDocs.pending : true;
  };

  // get the list of documents assigned to the client
  // return null if the list is still loading
  getClientDocs = () => {
    const { clientDocs } = this.props;

    if (this.isClientDocsPending()) {
      return null;
    }

    return clientDocs.data.list;
  };

  // returns true if it's a car order and the sales contract is missing
  // only true when employee and has rights to upload the sales contract
  isSalesContractMissing = () => {
    return false; // temporary (because we do not need the contract anymore - after talking to the lawyer mr Bardens 11.07.18)
    /* const { user } = this.props

    if (!may('ROLE_EMPLOYEE', user.roles) || this.isCarSalesApprovalPending()) {
      return false
    } else if (!this.isLeadPending() && !this.isLeadDocsPending()) {
      const leadDocs = this.getLeadDocs()

      if (leadDocs && false) {
        for (let i = 0; i < leadDocs.length; i++) {
          if (leadDocs[i].type && leadDocs[i].type.id === DOC_TYPE_SALES_CONTRACT) {
            // return false (we are not missing the sales contract) when the contract is here
            return false
          }
        }
      }
    } else {
      return false // return false when the lead docs list is still loading
    } */
  };

  // returns true if at least one shipping was initiated
  // only true if not an employee
  isShipped = () => {
    const { order, user } = this.props;

    if (
      (order.delivery_notes && order.delivery_notes.length > 0) ||
      (order.deliveryNotes && order.deliveryNotes.length > 0)
    ) {
      if (may('ROLE_CUSTOMER', user.roles)) {
        return true;
      }
    }

    return false;
  };

  // returns true if all items were shipped (or some items will not be shipped)
  isItemShippingCompleted = () => {
    const { order, user } = this.props;

    if (may('ROLE_EMPLOYEE', user.roles)) {
      return true;
    }

    return false;
  };

  // returns true if no shipping was made and cancellation is still possible
  // when it's a car order, also check if any service was already initiated
  isCancellationPossible = () => {
    const { order, user } = this.props;

    switch (order.type) {
      case 'item_sales': {
        break;
      }
    }

    return false;
  };

  // check the date between shipping and now and decide if returns are possible
  // only true when client (order target)
  isReturnPossible = () => {
    const { order, user } = this.props;

    if (may('ROLE_CUSTOMER', user.roles)) {
      switch (order.type) {
        case 'car_rent':
          // there is a special action to cancel car rental booking
          return false;
      }
    }

    return false;
  };

  // returns true if the user is a customer, the order is a car order and user requested to register the car in his name
  // also, we check if the bank data is really missing
  isBankDataMissing = () => {
    return false;
    // in the current kroschke process, we do not need the bank data
    /* const { order, user } = this.props

    if (isCarSalesOrder(order) && hasCarRegistration(order) && may('ROLE_CUSTOMER', user.roles)) {
      if (!user.financial || !user.financial.bank_data || !user.financial.bank_data.iban || !user.financial.bank_data.swift_bic) {
        return true
      }
    }

    return false */
  };

  // returns true if the user is an employee and an invitation should be sent
  // checks if order was marked as to be picked up
  isPickupInvitePending = () => {
    const { order, user } = this.props;

    if (may('ROLE_EMPLOYEE', user.roles) && order.shipping === 'pickup') {
      if (order.pickup_data && !order.pickup_data.invite_sent) {
        return true;
      }
      if (order.pickupData && !order.pickupData.inviteSent) {
        return true;
      }
    }

    return false;
  };

  // returns true if the pickup invite was sent and the order is not closed yet
  // only true when employee
  isPickupInviteSent = () => {
    const { order, user } = this.props;

    if (may('ROLE_EMPLOYEE', user.roles) && order.shipping === 'pickup') {
      if (!order.is_closed && order.pickup_data && order.pickup_data.invite_sent) {
        return true;
      }
      if (!order.isClosed && order.pickupData && order.pickupData.inviteSent) {
        return true;
      }
    }

    return false;
  };

  // check if the order is ready for customer review
  isReadyForReview = () => {
    /* const { order, user } = this.props;

    if (may('ROLE_CUSTOMER', user.roles)) {
    } */

    return false;
  };

  componentDidUpdate = prevProps => {
    const {
      intl: { messages },
      doNotify,
      orderActionSendPaymentInstructionsFormStatus,
      orderActionCancelOrderFormStatus,
      orderActionPickupInviteFormStatus,
      orderActionPickedUpFormStatus,
    } = this.props;
    const { isActive } = this.state;

    if (isActive) {
      // user sent payment instructions for the buyer
      if (
        prevProps.orderActionSendPaymentInstructionsFormStatus.pending &&
        !orderActionSendPaymentInstructionsFormStatus.pending &&
        !orderActionSendPaymentInstructionsFormStatus.hasError
      ) {
        this.closeSendPaymentInstructions();
        doNotify(1, messages.payment_instructions_sent);
      }

      // user (employee) cancelled the order
      if (
        prevProps.orderActionCancelOrderFormStatus.pending &&
        !orderActionCancelOrderFormStatus.pending &&
        !orderActionCancelOrderFormStatus.hasError
      ) {
        this.closeCancelOrder();
        doNotify(1, messages.order_cancelled);
      }

      // user (employee) sent an invitation to pick up the order
      if (
        prevProps.orderActionPickupInviteFormStatus.pending &&
        !orderActionPickupInviteFormStatus.pending &&
        !orderActionPickupInviteFormStatus.hasError
      ) {
        this.closeSendPickupInvite();
        doNotify(1, messages.pickup_invite_sent);
      }

      // user (employee) marked the order as picked up
      if (
        prevProps.orderActionPickedUpFormStatus.pending &&
        !orderActionPickedUpFormStatus.pending &&
        !orderActionPickedUpFormStatus.hasError
      ) {
        this.closeMarkPickedUp();
        doNotify(1, messages.order_picked_up);
      }
    }
  };

  getActions = () => {
    const {
      intl: { messages },
      appIntl,
      order,
      listItemComponent,
      user,
      addActions,
    } = this.props;

    const actions = addActions.slice();
    const buttonProps = {
      block: true,
    };

    const isOrderOpen = isOpen(order);

    if (isOrderOpen && this.isSalesContractMissing()) {
      const action = this.showUploadSalesContract;
      const icon = 'far fa-file-upload';
      const caption = messages.upload_sales_cotract;
      const key = 'upload-sales-contract';
      actions.push(
        listItemComponent === null ? (
          <Button {...buttonProps} onClick={action} key={key}>
            {caption}
          </Button>
        ) : (
          React.cloneElement(listItemComponent, { ...buttonProps, action, caption, icon, key })
        )
      );
    }

    if (isOrderOpen && this.isShipped()) {
      const action = () => {};
      const icon = 'far fa-box';
      const caption = 'Track delivery';
      const key = 'track-delivery';
      actions.push(
        listItemComponent === null ? (
          <Button {...buttonProps} onClick={action} key={key}>
            {caption}
          </Button>
        ) : (
          React.cloneElement(listItemComponent, { ...buttonProps, action, caption, icon, key })
        )
      );
    }

    if (isOrderOpen && this.isCancellationPossible()) {
      const action = this.showCancelOrder;
      const icon = 'far fa-times-square';
      const caption = messages.cancel_order;
      const key = 'cancel-order';
      actions.push(
        listItemComponent === null ? (
          <Button {...buttonProps} onClick={action} key={key}>
            {caption}
          </Button>
        ) : (
          React.cloneElement(listItemComponent, { ...buttonProps, action, caption, icon, key })
        )
      );
    }

    if (this.isReturnPossible()) {
      const action = () => {};
      const icon = 'far fa-undo-alt';
      const caption = 'Return item';
      const key = 'return-item';
      actions.push(
        listItemComponent === null ? (
          <Button {...buttonProps} onClick={action} key={key}>
            {caption}
          </Button>
        ) : (
          React.cloneElement(listItemComponent, { ...buttonProps, action, caption, icon, key })
        )
      );
    }

    if (isOrderOpen && may('ROLE_EMPLOYEE', user.roles) && !this.isItemShippingCompleted()) {
      const action = () => {
        this.props.actionExecuted('newDelivery');
        this.props.history.push(appIntl.urlPrefix + 'account/orders/' + order.id + '/createDelivery');
      };
      const icon = 'far fa-truck-loading';
      const caption = 'New delivery';
      const key = 'new-delivery';
      actions.push(
        listItemComponent === null ? (
          <Button {...buttonProps} onClick={action} key={key}>
            {caption}
          </Button>
        ) : (
          React.cloneElement(listItemComponent, { ...buttonProps, action, caption, icon, key })
        )
      );
    }

    if (isOrderOpen && this.isBankDataMissing()) {
      const action = this.showEnterBankData;
      const icon = 'fal fa-money-check-alt';
      const caption = messages.enter_bank_data;
      const key = 'enter-bank-data';
      actions.push(
        listItemComponent === null ? (
          <Button {...buttonProps} onClick={action} key={key}>
            {caption}
          </Button>
        ) : (
          React.cloneElement(listItemComponent, { ...buttonProps, action, caption, icon, key })
        )
      );
    }

    if (isOrderOpen && this.isPickupInvitePending()) {
      const action = this.showSendPickupInvite;
      const icon = 'far fa-calendar-check';
      const caption = messages.pickup_invite;
      const key = 'send-pickup-invite';
      actions.push(
        listItemComponent === null ? (
          <Button {...buttonProps} onClick={action} key={key}>
            {caption}
          </Button>
        ) : (
          React.cloneElement(listItemComponent, { ...buttonProps, action, caption, icon, key })
        )
      );
    }

    if (isOrderOpen && this.isPickupInviteSent()) {
      const action = this.showMarkPickedUp;
      const icon = 'far fa-box-check';
      const caption = messages.mark_picked_up;
      const key = 'mark-picked-up';
      actions.push(
        listItemComponent === null ? (
          <Button {...buttonProps} onClick={action} key={key}>
            {caption}
          </Button>
        ) : (
          React.cloneElement(listItemComponent, { ...buttonProps, action, caption, icon, key })
        )
      );
    }

    return actions;
  };

  render() {
    const { order, lead } = this.props;

    // if we do not have the lead data, we need to fetch it using data component
    // but we may not overwrite the lead data key
    let leadComponent = null;
    let leadDocsComponent = null;
    if ((order.lead_id && lead.data.id !== order.lead_id) || (order.leadId && lead.data.id !== order.leadId)) {
      leadComponent = (
        <DataId
          dataIdName="lead"
          dataIdId={order.lead_id || order.leadId}
          url={'/api/leads/' + (order.lead_id || order.leadId) + '.json'}
          key={'lead-data' + (order.lead_id || order.leadId)}
        />
      );
    }
    if (order.lead_id || order.leadId) {
      leadDocsComponent = (
        <DataId
          dataIdName="leadDoc"
          dataIdId={order.lead_id || order.leadId}
          url={'/api/documents.json?filters[lead]=' + (order.lead_id || order.leadId)}
          key={'lead-docs' + (order.lead_id || order.leadId)}
        />
      );
    }
    const clientDocsComponent = (
      <DataId
        dataIdName="clientDoc"
        dataIdId={order.target.username}
        url={'/api/documents.json?filters[target]=' + order.target.username}
        key={'client-docs' + order.target.username}
      />
    );
    const orderAuthorizationComponent = (
      <DataId
        dataIdName="orderAuthorization"
        dataIdId={order.id}
        url={`/api/orders/${order.id}/authorizations.json`}
        key={`order-auth-${order.id}`}
      />
    );

    const actions = this.getActions();
    const children = [leadComponent, leadDocsComponent, clientDocsComponent, orderAuthorizationComponent];
    for (let i = 0; i < actions.length; i++) {
      children.push(actions[i]);
    }

    children.push(
      <OrderCancelOrder
        show={this.state.showCancelOrder}
        close={this.closeCancelOrder}
        order={order}
        key="cancel-order-popup"
      />
    );

    children.push(
      <OrderFullRefund
        show={this.state.showFullRefund}
        close={this.closeFullRefund}
        order={order}
        key="full-refund-popup"
      />
    );

    children.push(
      <OrderEnterBankData
        show={this.state.showEnterBankData}
        close={this.closeEnterBankData}
        order={order}
        key="enter-bank-data-popup"
      />
    );

    children.push(
      <OrderSendPickupInvite
        show={this.state.showSendPickupInvite}
        close={this.closeSendPickupInvite}
        order={order}
        key="send-pickup-invite-popup"
      />
    );

    children.push(
      <OrderPickedUp
        show={this.state.showMarkPickedUp}
        close={this.closeMarkPickedUp}
        order={order}
        key="mark-picked-up-popup"
      />
    );

    if (this.props.wrapperComponent === null) {
      return children;
    }

    return React.cloneElement(this.props.wrapperComponent, {}, children);
  }
}
OrderActions.defaultProps = {
  wrapperComponent: <div />,
  listItemComponent: null,
  actionExecuted: () => {},
  addActions: [],
};

const mapStateToProps = (state, ownProps) => {
  return {
    appIntl: state.intl,
    user: state.login.user,
    lead: state.data.lead,
    leads: state.dataId.lead,
    leadDocs: state.dataId.leadDoc[ownProps.order.lead_id || ownProps.order.leadId],
    clientDocs: state.dataId.clientDoc[ownProps.order.target.username],
    orderActionSendPaymentInstructionsFormStatus: state.formStatus.orderActionSendPaymentInstructions,
    orderActionCancelOrderFormStatus: state.formStatus.orderActionCancelOrder,
    orderActionPickupInviteFormStatus: state.formStatus.orderActionPickupInvite,
    orderActionPickedUpFormStatus: state.formStatus.orderActionPickedUp,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    doNotify: (code, text) => {
      dispatch(addNotification(code, text));
    },
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps,
      null,
      { forwardRef: true }
    )(OrderActions),
    { forwardRef: true }
  )
);
